<template>
  <v-container fluid>
    <v-layout mt-2>
      <v-flex xs2 md2 pr-3>
        <v-select
          :items="vendorList"
          item-text="value"
          item-value="key"
          v-model="vendorStatus"
        ></v-select>
      </v-flex>
      <v-flex md2 xs2>
        <v-select
          :items="typeKeys"
          item-text="value"
          item-value="key"
          v-model="typeStatus"
        ></v-select>
      </v-flex>
      <v-flex ml-2 md5 xs8 >

        <v-autocomplete
          v-model="select"
          :loading="loading"
          :items="items"
          :search-input.sync="search"
          cache-items
          class="mx-4"
          flat
          hide-no-data
          hide-details
          label="引擎號碼查詢"
          solo
        ></v-autocomplete>
      </v-flex>
      <v-flex md4 xs4>
        <v-btn color="success" @click="searchEvent">搜尋</v-btn>
        <v-btn color="warning" @click="reset">重置</v-btn>
      </v-flex>
    </v-layout>
    <!--彈出視窗-->
    <alert-view
      :visible="messageDialog.visible"
      :title="messageDialog.title"
      :content="messageDialog.text"
      :isHtmlContent="true"
      :showCancel="messageDialog.showCancelButton"
      @cancelEvent="messageDialog.cancel"
      @confirmEvent="messageDialog.confirm"
    ></alert-view>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import MobileDetect from "mobile-detect";

import AlertView from "@/components/AlertView";
import TableView from "@/components/TableView";
import { getCurrentDate } from "@/pages/utils/tool";
import DatePicker from "@/components/DatePicker";
import RectifierEditDialog from "@/components/RectifierEditDialog";
import RectifierModel from "../../models/RectifierModel";
import ProductTypeDialog from "@/components/ProductTypeDialog";
import EcuManageDialog from "@/components/EcuManageDialog";
import common from '../../mixins/common';

const md = new MobileDetect(window.navigator.userAgent);
export default {
  name: "EngineSearchView",
  components: {
    ProductTypeDialog,
    AlertView,
    TableView,
    DatePicker,
    RectifierEditDialog,
    EcuManageDialog,
  },
  mixins:[common],
  data() {
    return {
      
      loading: false,
        items: [],
        search: null,
        select: null,
        states: [
          'Alabama',
          'Alaska',
          'American Samoa',
          'Arizona',
          'Arkansas',
          'California',
          'Colorado',
          'Connecticut',
          'Delaware',
          'District of Columbia',
          'Federated States of Micronesia',
          'Florida',
          'Georgia',
          'Guam',
          'Hawaii',
          'Idaho',
          'Illinois',
          'Indiana',
          'Iowa',
          'Kansas',
          'Kentucky',
          'Louisiana',
          'Maine',
          'Marshall Islands',
          'Maryland',
          'Massachusetts',
          'Michigan',
          'Minnesota',
          'Mississippi',
          'Missouri',
          'Montana',
          'Nebraska',
          'Nevada',
          'New Hampshire',
          'New Jersey',
          'New Mexico',
          'New York',
          'North Carolina',
          'North Dakota',
          'Northern Mariana Islands',
          'Ohio',
          'Oklahoma',
          'Oregon',
          'Palau',
          'Pennsylvania',
          'Puerto Rico',
          'Rhode Island',
          'South Carolina',
          'South Dakota',
          'Tennessee',
          'Texas',
          'Utah',
          'Vermont',
          'Virgin Island',
          'Virginia',
          'Washington',
          'West Virginia',
          'Wisconsin',
          'Wyoming',
        ],
      typeStatus: 0,
      vendorStatus: 0,
      messageDialog: {
        title: "",
        text: "",
        visible: false,
        showCancelButton: false,
        confirm: () => {},
        cancel: () => {},
      },
    };
  },
  created() {
  },
  watch: {
      search (val) {
        val && val !== this.select && this.querySelections(val)
      },
  },
  computed: {
    ...mapGetters(["getUserInfo", "getAgentList"]),
    typeKeys() {
      return [
        { key: 0, value: "整流器" },
        { key: 1, value: "ECU" },
      ];
    },
  },
  methods: {
    ...mapActions([
    ]),
    showMessageDialog(title, text, visible, confirmEvent, cancelEvent) {
      this.messageDialog.title = title;
      this.messageDialog.text = text;
      this.messageDialog.visible = visible;
      const self = this;
      this.messageDialog.confirm = () => {
        self.messageDialog.visible = false;
        if (confirmEvent) {
          confirmEvent();
        }
      };

      this.messageDialog.cancel = () => {
        self.messageDialog.visible = false;
        if (cancelEvent) {
          cancelEvent();
        }
      };
    },
    searchEvent() {
      this.loadData();
    },
    reset() {
      this.search.keyword = "";
      this.loadData();
    },
    loadData(){

    },
    querySelections (v) {
        this.loading = true
        // Simulated ajax query
        setTimeout(() => {
          this.items = this.states.filter(e => {
            return (e || '').toLowerCase().indexOf((v || '').toLowerCase()) > -1
          })
          this.loading = false
        }, 500)
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/web/EngineSearchView.vue